import { useCallback, useRef, useSyncExternalStore } from 'react';
import { toLoading, toEmpty } from '../resolvers/definition/resolverState';
import { useKey } from './useKey';
import { getPulseClient } from '../client/client';
import { normalizeResourceOptions } from '../resources/descriptors';
import { processStack } from '../devtools/processStack';
export { skipToken, isSkipToken, emptyInitialParams, normalizeResourceOptions } from '../resources/descriptors';
export const initial = Object.freeze(toLoading()());
export const skipped = toEmpty()();
export const usePulseClient = () => getPulseClient();
export const useParseOptions = (resource, options) => {
  const {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    passive
  } = normalizeResourceOptions(options);
  const instanceKey = useKey(resource, params);
  return {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    passive,
    instanceKey
  };
};
export const evictStaleSelectKeys = (cache, descriptors) => {
  const currentKeys = new Set();
  for (const d of descriptors) {
    if (d.select && !d.skip) {
      currentKeys.add(d.resource.identifyInstance(d.params));
    }
  }
  for (const key of cache.keys()) {
    if (!currentKeys.has(key)) {
      cache.delete(key);
    }
  }
};
export function applySelector(state, selector, cached) {
  if (cached && cached.source === state && cached.selector === selector) {
    return cached.result;
  }
  if (state.data === undefined) {
    return state;
  }
  const selectedData = selector(state.data);
  if (cached && Object.is(cached.result.data, selectedData)) {
    return cached.result;
  }
  return Object.assign({}, state, {
    data: selectedData
  });
}
export const useSyncResource = (getSnapshot, instanceKey, resource, params, skip, pollInterval, client, httpClient, pollGroup, passive) => {
  const stackRef = useRef(null);
  // eslint-disable-next-line react-hooks/refs
  if (stackRef.current === null && client !== null && client !== void 0 && client.devtoolsId) {
    var _processStack;
    // eslint-disable-next-line react-hooks/refs
    stackRef.current = (_processStack = processStack(new Error())) !== null && _processStack !== void 0 ? _processStack : '';
  }
  const subscribe = useCallback(callback => {
    var _stackRef$current;
    if (skip || !client) {
      return () => {};
    }
    return client.watch({
      resource,
      params,
      instanceKey,
      pollInterval,
      httpClient,
      pollGroup,
      passive
    }, callback, {
      kind: 'external',
      stack: (_stackRef$current = stackRef.current) !== null && _stackRef$current !== void 0 ? _stackRef$current : undefined
    });
  },
  // instanceKey is a proxy for params and resource type changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [client, instanceKey, pollInterval, pollGroup, skip, passive]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};